import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import cardImage from 'src/public/img/group_1196.png';
import arrowIcon from 'src/public/img/icon-arrow-forward.svg';
import mainImage from 'src/public/img/talking-people.svg';
import { AdditionalBenefitsModal } from 'src/modules/benefits/components/AdditionalBenefitsModal';
import { getCompanyAdditionalBenefits } from 'src/modules/benefits/selectors/benefitsSelectors';
import { Button, pxToRem } from '@modernhealth/vital-components';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    maxHeight: 1000,
    alignItems: 'center',
    justifyContent: 'center',
});

const Title = styled.h3(
    {
        marginTop: '2rem',
        color: color.ebonyClay,
    },
    font.black(font.size.extraLarge),
);

const Description = styled.p(
    {
        maxWidth: 670,
        marginBottom: 30,
        textAlign: 'center',
        lineHeight: '30px',
        color: color.blueBayoux,
    },
    font.roman(font.size.medium),
);

const CardWrapper = styled.div({
    display: 'flex',
    padding: 12,
    borderRadius: 5,
    boxShadow: '0px 4px 12px rgba(210, 221, 232, 0.65)',
    cursor: 'pointer',
});

const CardImage = styled.img({
    height: 46,
});

const CardInnerWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginLeft: 15,
});

const CardTitle = styled.p(
    {
        color: color.ebonyClay,
    },
    font.black(font.size.medium),
);

const CardDescription = styled.p(
    {
        color: color.blueBayoux,
    },
    font.roman(font.size.base),
);

const CardArrowIcon = styled.img({
    marginLeft: 20,
});

const ButtonsWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
    marginTop: 40,
});

export enum NoTherapySupportTestId {
    Continue = 'NoTherapySupportTestId.Continue',
    NotNow = 'NoTherapySupportTestId.NotNow',
}

export const NoTherapySupport: React.FC = () => {
    const { t } = useTranslation();
    const [modalVisible, setModalVisible] = useState(false);

    const history = useHistory();

    const additionalBenefits = useSelector(getCompanyAdditionalBenefits);

    const shouldShowAdditionalBenefits = additionalBenefits.length > 0;

    return (
        <>
            <Wrapper>
                <img src={mainImage} alt="people pleasantly talking" />
                <Title>{t('providers:no_therapy.title')}</Title>
                <Description>{t('providers:no_therapy.description')}</Description>

                {shouldShowAdditionalBenefits ? (
                    <CardWrapper onClick={() => setModalVisible(true)} role="button">
                        <CardImage src={cardImage} />
                        <CardInnerWrapper>
                            <CardTitle>
                                {t('providers:no_therapy.additional_benefits.title')}
                            </CardTitle>
                            <CardDescription>
                                {t('providers:no_therapy.additional_benefits.description')}
                            </CardDescription>
                        </CardInnerWrapper>

                        <CardArrowIcon src={arrowIcon} />
                    </CardWrapper>
                ) : null}

                <ButtonsWrapper>
                    <Button onClick={() => history.replace('/work-with-a-coach')}>
                        {t('providers:no_therapy.coach_connect')}
                    </Button>
                    <Button onClick={() => history.replace('/')} style={{ marginTop: pxToRem(5) }}>
                        {t('common.not_now')}
                    </Button>
                </ButtonsWrapper>
            </Wrapper>

            <AdditionalBenefitsModal
                visible={modalVisible}
                onToggle={() => setModalVisible(visible => !visible)}
            />
        </>
    );
};
